import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { useGetHistoryDisabledState } from 'app/modules/wallforming/components/placement-history/hooks/useGetHistoryDisabledState';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Redo = () => {
    const { t } = useTranslation();
    const disabled = useGetHistoryDisabledState();
    
    const { canRedo, redo } = usePlacementStore(
        useShallow((state) => ({
            canRedo: state.canRedo,
            redo: state.redo
        }))
    );

    return (
        <Menu.Item
            disabled={disabled || !canRedo}
            leftSection={<Icon aria-hidden="true" icon="redo" />}
            rightSection={<ActionShortcutHint actionId={InputActionId.GeneralRedo} className="min-w-52" />}
            onClick={() => redo()}
        >
            {t('redo')}
        </Menu.Item>
    );
};
